const doorLeafDirectionTypes = ['inward', 'outward'];

export default doorLeafDirectionTypes;
